import request from '../request';

const execute = async ({ userId }) => {
  const query = userId ? `?userId=${userId}` : '';
  try {
    const response = await request.get(`/pause${query}`);

    if (response.err) {
      return {
        err: true,
        data: {
          ...response.data,
        },
      };
    }

    return { err: false, data: response?.data };
  } catch (error) {
    return {
      err: true,
      data: {
        errorMessage: 'Erro interno',
        error,
      },
    };
  }
};

export default execute;
